<template>
    <div class="norele">
        <div class="description-box">
            请您把自己的<span class="color-red">用户名</span>提供给自己的管理者，管理者会给与相应的权限！然后<span class="color-red pointer" @click="toPage">重新登录</span>即可启用
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toPage() {
            this.$router.push({ path: '/login' })
        }
    }
}
</script>  

<style lang="scss" scoped>
.norele {
    width: 100vw;
    height: 100vh;
    background: url("../../assets/imags/welcome.jpg") no-repeat center/cover;
    overflow: hidden;

    .description-box{
        text-align: center;
        font-size: 34px;
        margin-top: 800px;
        user-select: none;
    }

    .color-red {
        color: red;
    }

    .pointer {
        cursor: pointer;
    }
}
</style>